import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesFeaturelistSection from "../../components/IndustriesFeatureListSection";
import {
    MiningBGVideo, MiningVideo, OverlayImg2,
    BusinessImpact,
    ConnectedMachines,
    StrategicOutcomes,
    ConnectedWorker,
    QualityManagement,
    ContractorPerformance,
    SafetyEnvironment,
    DigitalFoundations,
} from "../../constant";
import ThreeLongCard from "../../components/IndustriesThreeLongCard";
import ParaVideoSection from "../../components/IndustriesParaVideoSection";
import MiningAndMetalLanding from "../../components/Industries/MiningAndMetalLanding";

const AnimatedCardCrausalData = [
    {
        icon:ConnectedMachines,
        title: "Connected Machines",
        description:
            "Transform equipment data into operational intelligence through continuous monitoring of asset health, utilization, fuel consumption, and performance.",
        data: "By integrating IoT telemetry, predictive maintenance, condition-based monitoring, and fleet analytics, IENERGY helps mining organizations reduce unplanned downtime, optimize maintenance schedules, improve equipment availability, and maximize asset performance across the operation."
    },
    {
        icon:SafetyEnvironment,
        title: "Safety & Environment",
        description:
            "Gain end-to-end visibility into production, haulage, stockpile management, dispatch operations, and material movement across the mining value chain.",
        data: "By connecting production data, weighbridge systems, logistics workflows, and operational analytics, IENERGY enables better planning, improved throughput, optimized resource utilization, and timely delivery of materials from pit to plant, port, or customer."
    },
    {
        icon:ContractorPerformance,
        title: "Contractor Performance",
        description: "Digitally manage contractor onboarding, compliance, workforce productivity, safety performance, and service delivery through a unified contractor management framework.",
        data: "IENERGY provides complete visibility into contractor activities, qualifications, safety records, and performance metrics, helping organizations reduce contractor-related risks, improve accountability, and maintain consistent operational and safety standards across sites."
    },
    {
        icon:QualityManagement,
        title: "Quality Management",
        description: "Ensure product quality and operational consistency through integrated quality management processes that span inspections, sampling, laboratory testing, non-conformance tracking, and corrective actions.",
        data: " IENERGY enables greater traceability, faster issue resolution, and continuous improvement by connecting quality data with operational workflows, ensuring products consistently meet customer, regulatory, and business requirements."
    }


];

const longCardData = [
    {
        title: "Operational Outcomes",
        icon:StrategicOutcomes,
        listItems: [
            "Zero Harm Workplace",
            "Zero Environmental Incidents",
            "Reduced Operational Losses",
            "Stronger Compliance & Governance",
            "Sustainable Growth & Net Zero Progress"
        ]
    },
    {
        title: "Platform Capabilities",
        icon:StrategicOutcomes,

        listItems: [
            "Cloud-Native Architecture",
            "Industrial IoT Integration",
            "Real-Time Operational Visibility",
            "AI & Advanced Analytics",
            "Enterprise-Grade Security"
        ]
    },
    {
        title: "Measurable Value",
        icon:StrategicOutcomes,

        listItems: [
            "Improved Safety Performance",
            "Faster Decision-Making",
            "Higher Asset Reliability",
            "Increased Productivity",
            "Lower Operational Risk"
        ]
    }
];


const featurelist = {
    listTitle: "Driving Performance Across the Mining & Metals Value Chain",
    listSubTitle: "Mining organizations need real-time visibility across people, assets, production, and environmental performance to operate safely, efficiently, and sustainably. IENERGY helps transform fragmented operational data into actionable insights, enabling better decisions from mine planning through production, dispatch, and compliance.",
    listItems: [
        "Unify workforce, equipment, production, and sustainability data on a single enterprise platform for complete operational visibility.",
        "Improve asset utilization, production efficiency, and dispatch performance through real-time monitoring, analytics, and automated workflows.",
        "Strengthen safety, environmental compliance, ESG reporting, and risk management while supporting long-term operational resilience."
    ],
}

const leftSecionData = {
    title: "Purpose-Built for the Modern Mining Enterprise",
    para: ["From the mine face to the processing plant, mining leaders require real-time visibility into people, assets, operations, and environmental performance. IENERGY connects operational data across the enterprise to provide actionable insights that improve decision-making and drive measurable outcomes. Whether monitoring lone workers in remote locations, tracking equipment health, managing contractor compliance, optimizing dispatch operations, reporting ESG performance, or advancing Net Zero initiatives, IENERGY helps organizations transform operational complexity into operational excellence. The result is a safer workforce, more reliable assets, stronger compliance, improved productivity, and a connected mining operation built for the future"],
    mediaUrl: MiningVideo,
    imgeUrl: OverlayImg2,
}



export default function MiningAndMetalPage() {
    return (
        <>
            <MiningAndMetalLanding />
            <AnimatedCardCrausal
                title={"Connected Worker"}
                subTitle={"Empower frontline teams with real-time visibility, workforce monitoring, and digital safety controls across mining operations. From lone worker protection and geofencing to permit-to-work, fatigue monitoring, mobile inspections, and emergency response management, IENERGY helps organizations improve workforce safety, strengthen compliance, and enhance productivity while ensuring every worker remains connected, protected, and accountable."}
                data={AnimatedCardCrausalData}
            />


            <ParaVideoSection
                title={"Safer, Sustainable and Intelligent Mining Operations"}
                subTitle={"Mining organizations need more than disconnected systems and isolated data. They need a unified view of workforce safety, equipment performance, environmental impact, production efficiency, and operational risk. IENERGY brings together EHS, ESG, Net Zero, Connected Worker, Connected Machines, Production Intelligence, Contractor Performance, and AI-powered analytics on a single enterprise platform."}
                data={leftSecionData}
            />
            <ThreeLongCard
                title={"Turning Data into Measurable Business Outcomes"}
                subTitle={"Harness real-time insights, AI, automation, and digital innovation to improve performance, strengthen compliance, and create lasting business value."}
                data={longCardData}
            />
            <IndustriesFeaturelistSection data={featurelist} backgroundItem={MiningBGVideo} />
            <AchieveOutcome
                title={`Creating Lasting Value Across the Mining & Metals Lifecycle`}
                subTitle={`Purpose-built solutions that help mining enterprises streamline workflows, strengthen governance, optimize resource utilization, and improve business outcomes across the value chain. A unified digital ecosystem designed specifically for metals & mining enterprises.`}
            />

            <WeAreIED />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
